import { createContext, useContext } from "react";

/**
 * Embeddable calculators. /embed/<tool> renders a sizing calculator with no
 * site chrome, for other sites to put in an iframe. The snippet they paste
 * carries a plain credit link to the tool page outside the frame (links inside
 * an iframe count for nothing in search).
 */
export const EMBED_PREFIX = "/embed/";

export const isEmbedPath = (pathname: string) => pathname.startsWith(EMBED_PREFIX);

/** True inside /embed/<tool>: ToolPage drops the header, footer and site links. */
export const EmbedContext = createContext(false);
export const useIsEmbed = () => useContext(EmbedContext);

/** The message an embedded calculator posts to its host page with its height. */
export const EMBED_HEIGHT_MESSAGE = "loftloom-embed-height";

const SITE = "https://loftloom.com";

/** The tool page a calculator's embed snippet credits, tagged for analytics. */
export const embedCreditUrl = (toolPath: string) =>
  `${SITE}${toolPath}?utm_source=embed&utm_medium=referral&utm_campaign=calculator_embed`;

/**
 * The HTML another site pastes: the iframe, a credit line with a normal link,
 * and an optional few lines that size the frame to the calculator.
 */
export function embedSnippet(toolPath: string, toolName: string): string {
  const slug = toolPath.split("/").pop();
  const id = `loftloom-${slug}`;
  return [
    `<iframe id="${id}" src="${SITE}${EMBED_PREFIX}${slug}" title="${toolName}" width="100%" height="900" style="border:0;max-width:760px;width:100%" loading="lazy"></iframe>`,
    `<p style="font-size:13px">${toolName} by <a href="${embedCreditUrl(toolPath)}">LoftLoom</a></p>`,
    `<script>addEventListener("message",function(e){if(e.origin==="${SITE}"&&e.data&&e.data.type==="${EMBED_HEIGHT_MESSAGE}"&&e.data.slug==="${slug}"){var f=document.getElementById("${id}");if(f)f.style.height=e.data.height+"px"}})</script>`,
  ].join("\n");
}
